import { create } from 'zustand';
import type { UserSetting } from '@daynote/shared-types';
import { getDataSource } from '../data';
import { applyTheme } from '../lib/theme';

const DEFAULT_SETTING: UserSetting = {
  userId: '',
  theme: 'warm-wood',
  backgroundUrl: null,
  showLunar: true,
  showHoliday: true,
  weekStart: 1,
  maxRows: 5,
};

interface SettingsState {
  setting: UserSetting;
  loaded: boolean;
  loadSetting: () => Promise<void>;
  updateSetting: (patch: Partial<UserSetting>) => Promise<void>;
  applyCurrentTheme: () => void;
}

export const useSettingsStore = create<SettingsState>((set, get) => ({
  setting: DEFAULT_SETTING,
  loaded: false,

  loadSetting: async () => {
    try {
      const setting = await getDataSource().getSetting();
      set({ setting, loaded: true });
      applyTheme(setting.theme, setting.backgroundUrl);
    } catch {
      set({ loaded: true });
      applyTheme(DEFAULT_SETTING.theme);
    }
  },

  updateSetting: async (patch) => {
    const updated = await getDataSource().updateSetting(patch);
    set({ setting: updated });
    applyTheme(updated.theme, updated.backgroundUrl);
  },

  applyCurrentTheme: () => {
    const { setting } = get();
    applyTheme(setting.theme, setting.backgroundUrl);
  },
}));
